import * as constants from '../constants';

const duplicateEmailsInitialState = {
  emails: [],
  resendUrl: '',
  delayDisplayAlert: false,
};

export function invites(state = {}, action) {
  switch (action.type) {
    case constants.UPDATE_USER_INFO:
      return action.invites;
    case constants.ADD_EMAILS_SENT:
      return Object.assign({}, state, {
        sent: state.sent
          ? [].concat(state.sent).concat(action.emailList)
          : action.emailList,
      });
    default:
      return state;
  }
}

export function alertStatus(state = false, action) {
  switch (action.type) {
    case constants.CHANGE_ALERT_STATUS:
      return action.changeValue;
    default:
      return state;
  }
}

export function inputAreaHeight(state = '', action) {
  switch (action.type) {
    case constants.UPDATE_INPUT_AREA_HEIGHT:
      return action.height;
    default:
      return state;
  }
}

export function duplicateEmails(state = duplicateEmailsInitialState, action) {
  switch (action.type) {
    case constants.ADD_DUPLICATE_INFO:
      return Object.assign({}, state, {
        resendUrl: action.resendUrl,
        emails: action.emails,
      });
    case constants.TOGGLE_DELAY_DISPLAY_ALERT:
      return Object.assign({}, state, {
        delayDisplayAlert: action.status,
      });
    default:
      return state;
  }
}

export function restrictedEmails(state = [], action) {
  switch (action.type) {
    case constants.ADD_RESTRICTED_EMAILS:
      return action.emails;
    default:
      return state;
  }
}

export function invitesInfoReceived(state = false, action) {
  switch (action.type) {
    case constants.TOGGLE_INVITES_INFO_RECEIVED:
      return action.toggle;
    default:
      return state;
  }
}
